import { useNavigate } from "react-router";
import imgFranklinTeam1 from "../../assets/Franklin Team 1.png";
import imgMsrwfLogo1 from "../../assets/MSRWF Logo 1.png";
import { CiHeart } from "react-icons/ci";
import { IoIosArrowRoundForward } from "react-icons/io";

import { ButtonOrange } from "../../components/Button";
import { ButtonWhite } from "../../components/Button";

import styles from "./Home.module.css";

export function HeroSection() {
  const navigate = useNavigate();
  return (
    <section className={styles.heroSection}>
      <div className={styles.heroBackground}>
        <img alt="Mississippi road workers" src={imgFranklinTeam1} />
        <div className={styles.heroOverlay} />
      </div>

      <div className={styles.heroContent}>
        <div className={styles.heroLogoContainer}>
          <img
            alt="MSRWF Logo"
            className={styles.heroLogo}
            src={imgMsrwfLogo1}
          />
        </div>

        <div className={styles.heroText}>
          <h1 className={styles.heroTitle}>Supporting Mississippi's</h1>
          <h2 className={styles.heroSubtitle}>Road Workers</h2>
          <p className={styles.heroDescription}>
            Dedicated to providing assistance, resources, and support to the
            hardworking men and women who build and maintain Mississippi's
            roadways
          </p>
        </div>

        <div className={styles.heroButtons}>
          <ButtonOrange onClick={() => navigate("/donate")}>
            Make a Donation <CiHeart />
          </ButtonOrange>
          <ButtonWhite onClick={() => navigate("/contact")}>
            Get in Touch <IoIosArrowRoundForward />
          </ButtonWhite>
        </div>
      </div>
    </section>
  );
}
